import {
  Box,
  Flex,
  // Modal, ModalBody, ModalContent, ModalOverlay
} from "@chakra-ui/react";
import {
  //  LargeButton, LARGEL_BUTTON_TYPE,
  OverlayModal,
  Spacing,
} from "goi_common";

import { ParlorDetailProps } from "@/types/parlor";
import { useOverlay } from "@toss/use-overlay";
import {
  call,
  ColorIcon,
  colors,
  customEvent,
  FUNERAL_SIGUNGU,
  GoiLogo,
  HStack,
  // setVisitedFeature,
  // Spacing,
  useResponsive,
  VStack,
} from "goi_common";
import { useCallback, useEffect, useMemo, useState } from "react";
import ImageSlideSection from "./components/ImageSlideSection";
import MainInfoSection from "./components/MainInfoSection";

import { useRouter } from "next/router";
import FlowerModalContent from "./components/Modal/FlowerModalContent";
import ParlorFixedButtons from "./components/ParlorFixedButtons";
// import ParlorRequestBox from "./components/ParlorRequestBox/ParlorRequestBox";
import TabInfoSection from "./components/TabInfoSection";
import StarRating from "./components/TabInfoSection/ReviewInfoTabPanel/StarRating";
import ParlorDisplayNoneFooter from "./components/ParlorDisplayNoneFooter";
import ParlorRequestBox from "./components/ParlorRequestBox/ParlorRequestBox";

// import { useParlorDetailRevisitModal } from "@/hooks/useParlorDetailRevisitModal";

// import PremiumSalesRevisitParlorModal from "@/components/common/Modal/PremiumSalesRevisitParlorModal";
// import ParlorChatbot from "./components/Footer/ParlorChatbot";

function ParlorDetailContainer({
  parlor,
  closestParlorsByService,
  discountDescription,
  isExcluded,
  pageDescription,
}: {
  parlor: ParlorDetailProps;
  refetch: any;
  closestParlorsByService: any;
  discountDescription?: string;
  isExcluded: boolean;
  pageDescription: string;
}) {
  const [selectedSangjo, setSelectedSangjo] = useState("가족장");
  const overlay = useOverlay();
  const { isBiggerThanLg } = useResponsive();

  // const { isOpen: isOpenParlorModal, onClose: onCloseParlorModal } = useDisclosure();
  const router = useRouter();

  /** 재방문 모달 임시 제거
   * useParlorDetailRevisitModal();
   */

  // useEffect(() => {
  //   setVisitedFeature("parlor-detail");

  //   overlay.open(({ isOpen, close: onClose }) => {
  //     return (
  //       <OverlayModal
  //         onClose={onClose}
  //         isOpen={isOpen}
  //         closeOnOverlayClick
  //         modalContentStyle={{
  //           minWidth: "280px",
  //           overflow: "scroll",
  //         }}
  //         // overlayModalContent={<RevisitParlorModalContent onClose={onClose} />}
  //         overlayModalContent={<PremiumSalesRevisitParlorModal onClose={onClose} />}
  //       />
  //     );
  //   });
  // }, []);

  const openFlowerModal = useCallback(
    ({ parlorId }: { parlorId: number }) => {
      overlay.open(({ isOpen, close: onClose }) => {
        return (
          <OverlayModal
            onClose={onClose}
            isOpen={isOpen}
            closeOnOverlayClick={true}
            modalContentStyle={{
              minWidth: "380px",
              minHeight: isBiggerThanLg ? "" : "90vh",
            }}
            overlayModalContent={
              <FlowerModalContent
                companyName={parlor.companyname}
                parlorId={parlorId}
                onClose={onClose}
              />
            }
            header={{
              content: <FlowerModalContent.header onClose={onClose} />,
            }}
          />
        );
      });
    },
    [overlay, parlor, isBiggerThanLg],
  );

  useEffect(() => {
    if (router.query.showFlowerModal === "true") {
      openFlowerModal({
        parlorId: Number(parlor.id),
      });
    }
  }, [router.query, openFlowerModal]);

  const closestParlors = useMemo(() => {
    if (parlor) {
      return closestParlorsByService[selectedSangjo];
    }
  }, [selectedSangjo, parlor]);

  // const openQuestionSubmitModal = () => {
  //   overlay.open(({ isOpen: isOpenModal, close: onCloseModal }) => {
  //     return (
  //       <Box height="100%" width="100%">
  //         <Modal
  //           isOpen={isOpenModal}
  //           onClose={onCloseModal}
  //           closeOnOverlayClick
  //           scrollBehavior="inside"
  //           isCentered
  //           useInert={false}
  //         >
  //           <ModalOverlay width="100%" height="100%" />
  //           <ModalContent
  //             minWidth="300px"
  //             backgroundColor={colors.white}
  //             backgroundSize="cover"
  //             padding="0"
  //           >
  //             <ModalBody padding="0">
  //               <VStack>
  //                 <Box padding="24px" className="subtitle_18_b gray900">
  //                   빈소 할인 30만원, 미리 계약하기
  //                 </Box>
  //                 <Box
  //                   background={colors.warmGray100}
  //                   className="body_14_m gray700"
  //                   padding="24px 8px"
  //                   textAlign="center"
  //                   marginBottom="36px"
  //                 >
  //                   사전 계약 후,
  //                   <br /> 고이 장례 패키지를 이용하여
  //                   <br />
  //                   장례를 진행하는 경우.
  //                   <br />
  //                   빈소 할인 지원금 30만원을
  //                   <br /> <b>할인 혹은 페이백 형태로 지급</b>합니다.
  //                   <br />
  //                   <br />
  //                   <span className="caption_12_m orange650">
  //                     단, 고이장례연구소 상조 서비스중 회원가 기준 200만원 이상 상품(가족장 이상)을
  //                     이용하는 경우에 한하여 적용됩니다.
  //                   </span>
  //                 </Box>
  //                 <Box textAlign="center" className="caption_12_b black">
  //                   <a href="/service/">고이장례연구소 상조 서비스 확인하러가기 {">"}</a>
  //                 </Box>
  //                 <Box textAlign="center" className="caption_12_m black">
  //                   문의전화: 1666-9784
  //                 </Box>
  //                 <Box padding="24px 12px 12px">
  //                   <LargeButton
  //                     className="button_16_sb"
  //                     buttonType={LARGEL_BUTTON_TYPE.ORANGE}
  //                     onClick={() => {
  //                       router.push(
  //                         `https://prime.goifuneral.co.kr/registration/verification/?productKey=PARLOR30V3&account=1`,
  //                       );
  //                       customEvent({
  //                         newGtm: {
  //                           path: "home",
  //                           trigger_and_target: "parlor_detail-go_PARLOR30V2_contract",
  //                         },
  //                       });
  //                     }}
  //                   >
  //                     지금 가입하기
  //                     <br />
  //                     (빈소할인 30만원 보장)
  //                   </LargeButton>
  //                 </Box>
  //               </VStack>
  //             </ModalBody>
  //           </ModalContent>
  //         </Modal>
  //       </Box>
  //     );
  //   });
  // };

  return (
    <>
      <Box position="absolute" marginTop="-300px" color="#ffffffff">
        <p>{pageDescription}</p>
      </Box>
      {/* <ParlorModal
        isOpen={isOpenParlorModal}
        onClose={onCloseParlorModal}
        name={parlor.companyname}
      /> */}

      <VStack width="100%" alignItems="center">
        <VStack width="100%" maxWidth="480px">
          {!isExcluded && (
            <>
              <Box position="relative">
                {discountDescription && (
                  <Box
                    position="absolute"
                    top="20px"
                    left="12px"
                    zIndex="1"
                    background="rgba(0, 0, 0, 0.5)"
                    backdropFilter="blur(2px)"
                    borderRadius="18px"
                    padding="2px 10px 2px 2px"
                  >
                    <HStack gap="4px" alignItems="center" justifyContent="center">
                      <Box
                        margin="auto"
                        background={colors.gray900}
                        padding="4px"
                        borderRadius="50%"
                      >
                        <ColorIcon
                          name="icon-medal-check-mono"
                          color={colors.reviewYellow}
                          width={16}
                          height={16}
                        />
                      </Box>
                      <HStack gap="6px" alignItems="center" justifyContent="center">
                        <GoiLogo color={colors.white} size={16} />
                        <span className="button_12_sb white">빈소 할인 제휴 장례식장</span>
                      </HStack>
                    </HStack>
                  </Box>
                )}

                <ImageSlideSection images={parlor.images} name={parlor.companyname} />
              </Box>

              <Box position="absolute" marginTop="-500px" color="#ffffffff">
                <p>{pageDescription}</p>
              </Box>
              {/* <Box marginTop="-112px" zIndex="1">
                <HStack
                  gap={6}
                  height="112px"
                  padding="18px 16px"
                  background="#000000cc"
                  justifyContent="space-between"
                  alignItems="center"
                  css={{ cursor: "pointer" }}
                  onClick={() => {
                    openQuestionSubmitModal();
                    customEvent({
                      newGtm: {
                        path: "parlor_detail",
                        trigger_and_target: "image_banner-contract_parlor",
                      },
                    });
                  }}
                >
                  <VStack>
                    <div className={`body_14_m green150`}>
                      <Box className={`subtitle_16_b white`}>
                        빈소 할인 30만원, 미리 계약하기
                        <br />
                      </Box>
                      <Box className={`caption_12_b green50`}>
                        사전 계약 후(계약금 3만원) 고이 장례 패키지 이용, 장례 진행시
                        <br />
                        30만원 빈소 할인 지원금을 드립니다.
                        <br />
                        (패키지 200만원 이상 적용, 장례종료일 기준 30일 이내 지급)
                      </Box>
                    </div>
                  </VStack>
                  <VStack
                    background="white"
                    width="24px"
                    height="24px"
                    borderRadius="32px"
                    alignItems="center"
                    justifyContent="center"
                    boxShadow="0px 0px 12px rgba(0, 0, 0, 0.12)"
                  >
                    <ColorIcon name="arrow_right_small" size={16} color={colors.black} />
                  </VStack>
                </HStack>
              </Box> */}
              <MainInfoSection
                sido={parlor.sido}
                sigungu={parlor.sigungu}
                companyName={parlor.companyname}
                address={parlor.address}
                isDiscount={Boolean(discountDescription)}
                id={parlor.id}
                isExcluded={isExcluded}
              />
              {parlor && Number(parlor.id) !== 272 && (
                <TabInfoSection
                  isExcluded={isExcluded}
                  closestParlors={closestParlors}
                  discountDescription={discountDescription}
                  parlor={parlor}
                  selectedSangjo={selectedSangjo}
                  setSelectedSangjo={setSelectedSangjo}
                />
              )}
            </>
          )}
          {isExcluded && (
            <>
              <ImageSlideSection images={parlor.images} name={parlor.companyname} />
              <MainInfoSection
                sido={parlor.sido}
                sigungu={parlor.sigungu}
                companyName={parlor.companyname}
                address={parlor.address}
                isDiscount={Boolean(discountDescription)}
                id={parlor.id}
                isExcluded={isExcluded}
              />
              <Box
                padding="32px"
                margin="30px"
                background={colors.gray100}
                className="subtitle_18_m gray600"
                borderRadius="16px"
              >
                <span className="gray900">
                  해당 장례식장의 요청에 의해
                  <br />
                  가격, 비용정보, 후기, 사진 등의 정보를 제공하지 않습니다.
                  <br />
                </span>
                {
                  FUNERAL_SIGUNGU.get(Number(parlor.sido))?.get(Number(parlor.sigungu)) as string
                }{" "}
                지역 장례식장 비용 비교, 지역내 장례식장 정보가 궁금하신 경우
                e하늘장사정보시스템(https://15774129.go.kr/intro.do)
                <br />
                혹은 <b className="orange700">고이 24시간 고객센터{"(1666-9784)"}</b>로 문의해주세요
              </Box>
            </>
          )}
          {/* <MainInfoSection
            sido={parlor.sido}
            sigungu={parlor.sigungu}
            companyName={parlor.companyname}
            address={parlor.address}
            isDiscount={Boolean(discountDescription)}
            id={parlor.id}
            isExcluded={isExcluded}
          /> */}

          {String(parlor.id) === "76" && (
            <HStack padding="8px 24px" alignItems="center" gap="24px">
              <StarRating score={3.0} />
              <Box
                className="caption_12_b gray500"
                onClick={() => {
                  window.open("https://place.map.kakao.com/1115026216#comment");
                }}
              >
                카카오맵 후기 <span className="caption_11_b gray800">{"더보기 >"}</span>
              </Box>
            </HStack>
          )}

          {parlor && Number(parlor.id) == 272 && (
            <Box padding="20px 20px">
              <Box
                borderRadius={4}
                background={colors.green500}
                boxShadow="4px 4px 4px #00000044"
                className="subtitle_21_b white"
                padding="16px"
                marginBottom="16px"
                textAlign="center"
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "parlor_detail",
                      trigger_and_target: "deceased_test0_match_request",
                    },
                  });
                  router.push("/match/request/");
                }}
              >
                온라인 미리 견적(비용 예상) {">>"}
              </Box>
              <Box className="subtitle_18_b gray900" marginBottom="16px">
                조문객
              </Box>
              <HStack gap={12}>
                <Box
                  width="100%"
                  borderRadius={4}
                  background={colors.green400}
                  boxShadow="4px 4px 4px #00000044"
                  className="subtitle_18_b white"
                  padding="16px"
                  marginBottom="16px"
                  alignItems="center"
                  justifyContent="center"
                  textAlign="center"
                  onClick={() => {
                    customEvent({
                      newGtm: {
                        path: "parlor_detail",
                        trigger_and_target: "visit_test1_flower",
                      },
                    });
                    router.replace({
                      query: { ...router.query, showFlowerModal: true },
                    });
                  }}
                >
                  빈소에 화환 보내기
                  <br />
                  <span className="caption_12_b">(심야/야간 주문시 아침 발송)</span>
                </Box>
                <Flex
                  borderRadius={4}
                  background={colors.green400}
                  className="subtitle_18_b white"
                  padding="16px"
                  marginBottom="16px"
                  textAlign="center"
                  onClick={() => {
                    customEvent({
                      newGtm: {
                        path: "parlor_detail",
                        trigger_and_target: "visit_test2_info",
                      },
                    });
                    alert(
                      "해당 정보는 개인정보 등에 해당하여 장례식장에 직접 문의해주세요. 장례 준비중이신 경우라면 비용, 위치, 절차 등 하단 미리준비를 눌러주세요",
                    );
                  }}
                >
                  고인 정보, 위치, 주차 문의
                </Flex>
              </HStack>
              <Box className="subtitle_18_b gray900" marginBottom="16px">
                장례 준비, 임종 문의
              </Box>
              <HStack gap={12} width="100%">
                <Box
                  width="100%"
                  borderRadius={4}
                  background={colors.green500}
                  className="subtitle_21_b white"
                  padding="16px"
                  marginBottom="16px"
                  textAlign="center"
                  boxShadow="4px 4px 4px #00000044"
                  onClick={() => {
                    customEvent({
                      newGtm: {
                        path: "parlor_detail",
                        trigger_and_target: "deceased_test1_call",
                      },
                    });
                    call("1666-9784");
                  }}
                >
                  임종 접수
                  <br />
                  이송 요청
                </Box>
                <Box
                  width="100%"
                  borderRadius={4}
                  background={colors.green500}
                  className="subtitle_18_b white"
                  padding="16px"
                  marginBottom="16px"
                  textAlign="center"
                  boxShadow="4px 4px 4px #00000044"
                  onClick={() => {
                    customEvent({
                      newGtm: {
                        path: "parlor_detail",
                        trigger_and_target: "deceased_test2_process_chat",
                      },
                    });
                    window.open("http://pf.kakao.com/_xgFDaK/chat");
                  }}
                >
                  미리 준비(채팅)
                  <br />
                  (절차/비용문의)
                </Box>
              </HStack>

              <Box
                borderRadius={4}
                background={colors.green500}
                boxShadow="4px 4px 4px #00000044"
                className="subtitle_18_b white"
                padding="16px"
                marginBottom="16px"
                textAlign="center"
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "parlor_detail",
                      trigger_and_target: "deceased_test4_match_request",
                    },
                  });
                  router.push("/match/request/");
                }}
              >
                장례 전체비용, 장례식장, 장지비용 확인
              </Box>
              <Box width="100%" alignItems="center">
                {/* {variation === "A" && (
            <Box width="100%" alignItems="center">
              <Box width="100%" maxWidth="480px" padding="12px" margin="auto">
                <TotalPriceSection
                  expectedCharges={parlor.expected_charge_sum}
                  selectedSangjo="가족장"
                />
              </Box>
            </Box>
          )} */}
                {/* <Box>
            <TopBanner path="parlor_detail" />
          </Box> */}
                <Box width="100%" alignItems="center">
                  <Box width="100%" maxWidth="480px" padding="12px" margin="auto">
                    {/* <Spacing gap={40} /> */}
                    <ParlorRequestBox
                      sido={parlor.sido}
                      sigungu={parlor.sigungu}
                      companyName={parlor.companyname}
                    />
                  </Box>
                </Box>
                <Spacing gap={120} />
              </Box>
            </Box>
          )}

          {/* <AmenityInfoTabPanel parlor={parlor} /> */}
        </VStack>
      </VStack>
      {/* <CallFixedButton maxWidth="480px" bottom={{ md: "72px" }} /> */}
      {/* <ParlorPromotionModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        name={parlor.companyname}
      /> */}
      {/* <StepGuideFooter /> */}
      <ParlorFixedButtons
        parlor={parlor}
        selectedSangjo={selectedSangjo}
        closestParlors={closestParlors}
      />
      {/* <ParlorChatbot companyname={parlor.companyname} /> */}

      {/* 서울성모병원장례식장 공홈인척 footer 달기 */}
      {parlor && Number(parlor.id) === 28 && (
        <ParlorDisplayNoneFooter
          tel="02-2258-5940"
          fax="02-2258-5943"
          address="서울시 서초구 반포대로 222 (반포동) 학교법인가톨릭학원 서울성모장례식장"
          copyright="COPYRIGHT 2024 CATHOLIC EDUCATION FOUNDATION SEOUL ST.MARY'S FUNERAL HALL. ALL RIGHTS RESERVED."
        />
      )}

      {/* 배성병원장례식장 공홈인척 footer 달기 */}
      {parlor && Number(parlor.id) === 174 && (
        <ParlorDisplayNoneFooter
          tel="053-382-1600"
          fax=""
          address="대구광역시 북구 검단로 140"
          copyright="COPYRIGHT 2024 BASEONG FUNERAL HALL. ALL RIGHTS RESERVED."
        />
      )}
    </>
  );
}
export default ParlorDetailContainer;
